import React from 'react'

import Space from '../../../components/SpaceContent'

import What from './What'
import Where from './Where'



const Workspace = ({ page }) => {
    return (
        <>
            <Space>
                <What page={ page } />
                <Where />
            </Space>
        </>
    )
}

export default Workspace